module.exports = __webpack_public_path__ + "static/media/Gold.36e6592a.svg";